import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./layout/Layout";

import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "animate.css";
import AOS from "aos";
import "aos/dist/aos.css";

import WOW from "wowjs";

// ---------- HiTech Pages ----------
import Home from "./components/HiTech/Home";
// import Services from "./components/HiTech/PrivacyPolicy";
import About from "./components/HiTech/About";
import Project from "./components/HiTech/Project";
import Contact from "./components/HiTech/Contact";
import ThankYou from "./components/HiTech/ThankYou";
import Courses from "./components/HiTech/Courses";
import CourseDetails from "./components/HiTech/CourseDetails";


// ---------- HiTech CSS ----------
import "./assets/css/HiTech/bootstrap.min.css";
import "./assets/css/HiTech/bootstrap-icons.min.css";
import "./assets/css/HiTech/animate.min.css";
import "./assets/css/HiTech/style.css";
import "./assets/css/courseDetails1.css";
// import "./assets/css/coursesSection2.css";
import "./assets/css/contact2.css";

// import "./assets/css/courseDetails2.css";
// import "./assets/css/courseDetails3.css";

import PrivacyPolicy from "./components/HiTech/PrivacyPolicy";
import Locations from "./components/HiTech/Locations";
import Services from "./components/HiTech/Services";
// import "./assets/css/HiTech/TeamSection.css";

function App() {
  useEffect(() => {
    // Initialize WOW.js (scroll animations)
    // new WOW.WOW({ live: false }).init();

    AOS.init({
      duration: 1000,
      once: true,
    });
  }, []);

  return (
    // ✅ Wrap your entire route tree inside <Router>
   <Routes>
      <Route element={<Layout />}>
      
      {/* //----------Cources Links-------- */}
        {/* <Route index element={<Home />} />
        <Route path='/courses' element={<Courses />} />
        <Route path="/news" element={<News />}/>
        <Route path="/contact" element={<Contact />} />
        <Route path="/elements" element={<Elements />} /> */}


      
      {/* //----------Hitech Links-------- */}
        <Route index element={<Home />} />
        <Route path='/privacy-policy' element={<PrivacyPolicy />} />
        <Route path='/about' element={<About />} />
        <Route path='/project' element={<Project />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/courses' element={<Courses />} />
        <Route path='/locations' element={<Locations />} />
        <Route path='/services' element={<Services />} />
        <Route path="/thank-you" element={<ThankYou />} />
        <Route path='/course/details/:slug' element={<CourseDetails />} />


        {/* ... */}
        <Route path="*" element={<div className="container py-5"><h1>404 – Not Found</h1></div>} />
      </Route>
    </Routes>
  );
}

export default App;
